export interface ApiStatusActionType {
  type: ApiStatus;
  payload?: any;
}

export enum ApiStatus {
  SET_POST_API_STATUS = "SET_POST_API_STATUS",
  SET_PUT_API_STATUS = "SET_PUT_API_STATUS",
}
